enum SocialMediaIconType {
    Facebook,
    Twitter,
    Youtube,
    Facebook_outlined,
    Instagram_outlined,
    Youtube_outlined
}

export default SocialMediaIconType